import React, { useEffect } from 'react';
import RollupPanel from '../Sos2/RollupPanel';   // REUSED unchanged: the app's Patterns tab

// The app's Patterns tab (what recurs at each level: scene, sequence, act), in the snapshot's own
// modal shell (DetailModal). Read-only. "Show these" marks the pattern's units on the strip; a
// unit chip opens that unit's reading. Owner, 2026-10-23: patterns belong in the LR snapshot.
const unitWord = (m) => {
  const one = m.grain === 'act' ? 'act' : m.grain === 'sequence' ? 'sequence' : 'scene';
  return m.count === 1 ? one : `${one}s`;
};

export default function PatternsModal({ rollups, script, title, marked, onClose, onShowUnits, onSelectUnit }) {
  // RollupPanel's "light all N on the timeline →" button and its "Outlined on the timeline ↑" chip
  // both mean "show me on the map": the units are already marked, so close to reveal them. Matched by
  // their wording so RollupPanel stays unchanged for the app.
  const onClickCapture = (e) => {
    const el = e.target.closest && e.target.closest('button, [role="link"]');
    if (el && /on the timeline/i.test(el.textContent || '')) { e.preventDefault(); e.stopPropagation(); onClose(); }
  };
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="lrs-modal-overlay" onClick={onClose}>
      <div className="lrs-modal lrs-modal--patterns" role="dialog" aria-modal="true"
           aria-label={title ? `Patterns in ${title}` : 'Patterns'} onClick={(e) => e.stopPropagation()} onClickCapture={onClickCapture}>
        {marked ? (
          <button type="button" className="lrs-pat-reveal" onClick={onClose}>
            {marked.count} {unitWord(marked)} outlined on the map. Show me ↑
          </button>
        ) : null}
        <button type="button" className="lrs-modal-close" aria-label="Close" onClick={onClose}>×</button>
        <div className="lrs-modal-body">
          <h2 className="lrs-pat-title">Patterns{title ? <> in <i>{title}</i></> : null}</h2>
          <p className="lrs-pat-lede">What keeps coming back across the scenes, sequences and acts, and what to protect.</p>
          <RollupPanel rollups={rollups} grain="overview" script={script} neutral
                       onShowUnits={onShowUnits} onSelectUnit={onSelectUnit} />
        </div>
      </div>
    </div>
  );
}
